import { getFacetRequests } from '../features/facets/generic/interfaces/generic-facet-request.js';
export function sortFacets(facets, sortOrder) {
    const payloadMap = {};
    facets.forEach((f) => {
        payloadMap[f.facetId] = f;
    });
    const sortedFacets = [];
    sortOrder.forEach((facetId) => {
        if (facetId in payloadMap) {
            sortedFacets.push(payloadMap[facetId]);
            delete payloadMap[facetId];
        }
    });
    const remainingFacets = Object.values(payloadMap);
    return [...sortedFacets, ...remainingFacets];
}
function getRangeFacetRequests(state) {
    return getFacetRequests(state).map((request) => {
        const currentValues = request.currentValues;
        const hasActiveValues = currentValues.some(({ state }) => state !== 'idle');
        if (request.generateAutomaticRanges && !hasActiveValues) {
            return { ...request, currentValues: [] };
        }
        return request;
    });
}
export const sortCriteriaMap = {
    alphanumericDescending: { type: 'alphanumeric', order: 'descending' },
    alphanumericNaturalDescending: {
        type: 'alphanumericNatural',
        order: 'descending',
    },
};
function getSpecificFacetRequests(state) {
    return getFacetRequests(state).map((request) => {
        /* The Search API does not support 'alphanumericDescending' as a string value and instead relies on a new sort mechanism to specify sort order.
        At the moment, this is only supported for alphanumeric sorting, but will likely transition to this pattern for other types in the future. */
        const sortCriteria = sortCriteriaMap[request.sortCriteria];
        if (sortCriteria) {
            return {
                ...request,
                sortCriteria,
            };
        }
        return request;
    });
}
function getAllFacets(state) {
    return [
        ...getSpecificFacetRequests(state.facetSet ?? {}),
        ...getRangeFacetRequests(state.numericFacetSet ?? {}),
        ...getRangeFacetRequests(state.dateFacetSet ?? {}),
        ...getFacetRequests(state.categoryFacetSet ?? {}),
    ];
}
function getAllEnabledFacets(state) {
    return getAllFacets(state).filter(({ facetId }) => state.facetOptions?.facets[facetId]?.enabled ?? true);
}
export function getFacets(state) {
    return sortFacets(getAllEnabledFacets(state), state.facetOrder ?? []);
}
